<template>
  <transition
    enter-active-class="duration-300 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="duration-200 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div v-if="show" :class="fixed ? 'fixed' : 'absolute'" class="inset-0">
      <div class="bg-white absolute inset-0 opacity-50" />
      <div class="flex items-center justify-center h-full">
        <TLoader />
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
defineProps({
  show: {
    type: Boolean,
  },
  fixed: {
    type: Boolean,
    default: true,
    required: false,
  },
})
</script>
